export const feeMethodOptions = [
  { value: 0, label: '不收费' },
  { value: 1, label: '队员独立付费' },
  { value: 2, label: '领队付费(固定金额)' },
  { value: 3, label: '领队付费(按人数)' }
]

export const orderStatusOptions = [
  { value: 0, label: '待支付' },
  { value: 1, label: '已支付' },
  { value: 2, label: '申请退款' },
  { value: 3, label: '已退款' },
  { value: -1, label: '已取消' }
]

export const attachOptions = [
  { label: 'attackIP', name: '上场局数' },
  { label: 'attackPA', name: '轮击次数' },
  { label: 'attackAB', name: '击球次数' },
  { label: 'attackR', name: '得分' },
  { label: 'attackH', name: '安打' },
  { label: 'attack2B', name: '二垒打' },
  { label: 'attack3B', name: '三垒打' },
  { label: 'attackHR', name: '本垒打' },
  { label: 'attackGDP', name: '地滚球双杀' },
  { label: 'attackSH', name: '牺牲打' },
  { label: 'attackSF', name: '牺牲高打' },
  { label: 'attackHP', name: '投球中身' },
  { label: 'attackIO', name: '妨碍上垒' },
  { label: 'attackBB', name: '四环球' },
  { label: 'attackSB', name: '偷垒' },
  { label: 'attackCS', name: '偷垒被杀' },
  { label: 'attackK', name: '三击不中' },
  { label: 'attackRBI', name: '得分打' },
  { label: 'attackPO', name: '接杀' },
  { label: 'attackA', name: '助杀' },
  { label: 'attackE', name: '失误' },
  { label: 'attackNH', name: '非安打上垒' }
]

export const pitchingOptions = [
  { label: 'pitchingIP', name: '投球局数' },
  { label: 'pitchingBF', name: '投球人次' },
  { label: 'pitchingAB', name: '自击人数' },
  { label: 'pitchingR', name: '得分' },
  { label: 'pitchingER', name: '责任失分' },
  { label: 'pitchingH', name: '安打' },
  { label: 'pitchingHR', name: '被本垒打' },
  { label: 'pitching2B', name: '被二垒打' },
  { label: 'pitching3B', name: '被三垒打' },
  { label: 'pitchingSH', name: '被牺牲打' },
  { label: 'pitchingSF', name: '被牺飞打' },
  { label: 'pitchingBB', name: '四环球' },
  { label: 'pitchingIBB', name: '故意四球' },
  { label: 'pitchingHP', name: '投球中身' },
  { label: 'pitchingIO', name: '妨碍上垒' },
  { label: 'pitchingK', name: '三击不中' },
  { label: 'pitchingWP', name: '投手暴投' },
  { label: 'pitchingBK', name: '投手犯规' }
]

export const catcherOptions = [
  { label: 'catcherPB', name: '接手漏接' },
  { label: 'catcherSB', name: '偷垒成功' },
  { label: 'catcherCS', name: '偷垒被杀' }
]

export const playerSignupFieldsLabel = {
  trueName: '姓名',
  bmBirthday: '出生日期',
  qualificationFile: '资质证明',
  insureFile: '保险证明',
  nationality: '国籍',
  gender: '性别',
  mobile: '联系电话',
  bmEmail: '邮箱',
  certType: '证件类型',
  IDCardNo: '证件号码',
  customText1: '自定义单选1',
  customText2: '自定义单选3',
  customText3: '自定义单选2',
  serialNumber: '注册证号'
}